export const routingUtil = {
    routes: {
      root: '/',
      portfolio: '/portfolio',
    }
  }